 export class RespostaListaDinamica {

   public colunas: String[];
   public linhas: String[][];


 }
